import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import { registerServiceWorker } from './utils/pwaUtils';

// Manejar errores no capturados
window.addEventListener('error', (event) => {
  console.error('Error global:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Promise rechazada no manejada:', event.reason);
});

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  registerServiceWorker().catch((error) => {
    console.error('Error al registrar Service Worker:', error);
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No se encontró el elemento root');
}

console.log('🚀 Iniciando aplicación React...');
console.log('🔍 Root element encontrado:', rootElement);

try {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('✅ Aplicación React renderizada correctamente');
} catch (error) {
  console.error('❌ Error al renderizar aplicación:', error);
  throw error;
}

